G.BuildEnvironment = {
  production: false,
  // testPurchaseSdk: true,
  version: 'DEV',
  APP_ID: 'candy-match-3',
  // RAVEN_DSN: "https://b791a54129c546c6a461ca3858de3675@sentry.io/1204916",
  GAGK: '7aa9cd7cc6c19928278a4fc14d2a5f25',
  GASK: 'a6c4fad91133f3cdd7ea46c810d8e54d181ee76d',
  isCookOMT: false,

  adPlacementIDs: {
    REWARDED: '1255697821230772_1255698634564024',
    INTERSTITIAL: '1255697821230772_1255698584564029',
  },

  adPlacements: {
    skipMission: { adType: 'REWARDED', g_adName: 'skipMission' },
    spinTheDailyWheel: { adType: 'REWARDED', g_adName: 'spinTheDailyWheel' },
    requestMoveHelpWheelSpin: { adType: 'REWARDED', g_adName: 'requestMoveHelpWheelSpin' },
    claimExtraGift: { adType: 'REWARDED', g_adName: 'claimExtraGift' },
    claimAllGifts: { adType: 'REWARDED', g_adName: 'claimAllGifts' },
    achievementGift: { adType: 'REWARDED', g_adName: 'achievementGift' },
    doubleDailyReward: { adType: 'REWARDED', g_adName: 'doubleDailyReward' },
    preLevelBooster: { adType: 'REWARDED', g_adName: 'preLevelBooster' },
    retryChallenge: { adType: 'REWARDED', g_adName: 'retryChallenge' },
    addLife: { adType: 'REWARDED', g_adName: 'addLife' },
    spinTheLevelLostWheel: { adType: 'REWARDED', g_adName: 'spinTheLevelLostWheel' },
    double3hGift: { adType: 'REWARDED', g_adName: 'double3hGift' },
    doubleLevelCoins: { adType: 'REWARDED', g_adName: 'doubleLevelCoins' },
    rewarded: { adType: 'REWARDED', g_adName: 'rewarded' },
    redoMission: { adType: 'REWARDED', g_adName: 'redoMission' },
    chestShuffleRetry: { adType: 'REWARDED', g_adName: 'chestShuffle' },
    firstInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'firstInterstitialInSession' },
    secondInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'secondInterstitialInSession' },
    interstitial: { adType: 'INTERSTITIAL', g_adName: 'interstitial' },
  },
};
